import { Box, Button } from '@material-ui/core';
import React, { FC } from 'react';
import { PrizeCategory } from '../../../types/prize';
import "./index.css";

interface Props {
    categories: Array<PrizeCategory>;
    search?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleSelectedCategory: (id: string, checked: boolean) => void;
    clearCategory: (clear: string) => void;
    selectedCategories: Array<string>;
    applyCategoryFilter: () => void;
    selectedAllCategories: (event: React.ChangeEvent<HTMLInputElement>) => void;
    appointment: string;
    searchString?: string;
    hideSearch?: boolean
}

const FilterComponent: FC<Props> = ({
    categories,
    search,
    handleSelectedCategory,
    clearCategory,
    selectedCategories,
    applyCategoryFilter,
    selectedAllCategories,
    appointment,
    searchString,
    hideSearch
}) => {
    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const checked = event.target.checked
        const id = event.target.value
        handleSelectedCategory(id, checked)
    }

    const handleChecked = (id: string): boolean => {
        let checked = false
        // eslint-disable-next-line array-callback-return
        selectedCategories.map((item) => {
            if (item === id) {
                checked = true
            }
        })
        return checked
    }

    const selectItemByTitle = (id: string) => {
        let isSelected = true
        selectedCategories.map((item) => {
            if (item === id) {
                isSelected = false
            }
        })
        handleSelectedCategory(id, isSelected)
    }

    const handleAllChecked = (): boolean => {
        let checked = false
        if (categories.length === selectedCategories.length) {
            checked = true
        }
        return checked
    }

    const clearSelectedItem = (): void => {
        clearCategory(appointment)
    }

    const emptyDropDown = (appointment: string): string => {
        switch (appointment) {
            case "selectedPrizes":
                return "No prizes"
            case "selectedCategories":
                return 'No categories'
            case "selectedSubCategories":
                return "No sub-categories"
            case "selectedTitles":
                return "No Titles"
            case "selectedIds":
                return "No Ids"
            default:
                return "No Users"
        }
    }

    return (
        <div className="filter-dropdown">
            {!hideSearch && <input placeholder="search" name={appointment} value={searchString} onChange={search} />}
            {categories.length === 0 ? <div>
                {emptyDropDown(appointment)}
            </div> :
                <>
                    {categories.length > 1 && <div><input className="category-checkbox" checked={handleAllChecked() ? true : false} type="checkbox" onChange={selectedAllCategories} />
                        <span className="category-title">
                            All
                </span>
                    </div>}
                    <div className="filter-container">
                        {
                            categories.map((item, i) => {
                                return (
                                    <>
                                        <div key={i} className="filter-item"><input className="category-checkbox" type="checkbox" checked={handleChecked(item.id) ? true : false} value={item.id} onChange={handleSelect} />
                                            <span className={item.isActive === false? 'inactive-category category-title':`category-title`} onClick={() => selectItemByTitle(item.id)}>
                                                {item.title}
                                            </span>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                    <hr />
                    <div className="filter-button-container">
                        <Box display="flex" justifyContent="space-evenly" alignItems="center" paddingTop="1em">
                            <Button id="apply-button" onClick={applyCategoryFilter}>Filter</Button>
                            <Button id="clear-button" onClick={clearSelectedItem}>Clear</Button>
                        </Box>
                    </div>
                </>
            }
        </div>
    )
}

export default FilterComponent